import { getExecEndpoint } from '~/api/service/getExecEndpoint';
import { BqResponse } from '~/api/def/endpoints/types';
import { documentEndpoint } from '~/api/def/endpoints/document/documentEndpoint';

/**
 * @tags document
 * @name endpointLinkedDocumentsGET
 * @summary Get extracted fields from a document.
 * @param docId The document ID.
 * @request GET:/document/{docId}/linked-document
 * */
export const endpointLinkedDocumentsGET = async (docId: string) => {
  return await documentFieldExec<'GET'>({
    method: 'GET',
    urlExtra: `/${docId}/linked-document`,
  });
};

const documentFieldExec =
  getExecEndpoint<LinkedDocumentsResponseDef>(documentEndpoint);
interface LinkedDocumentsResponseDef {
  endpoint: typeof documentEndpoint;
  methods: {
    GET: {
      response: GetLinkedDocumentsResponse;
    };
  };
}

export type GetLinkedDocumentsResponse = BqResponse<{
  data: LinkedDocument[];
}>;

export type LinkedDocument = {
  id: string;
  originalName: string;
  internalUrl: string;
  extractionStatus: string;
  liveness: boolean;
  restated: boolean;
  type: string;
  fundId: string;
  investorName: string;
  admissionDate: string;
};
